var map = {
	"./1024": 157,
	"./1024.png": 157,
	"./512": 158,
	"./512.png": 158,
	"./Grubspotr-SpotrOS Logo": 159,
	"./Grubspotr-SpotrOS Logo.svg": 159,
	"./Grubspotr-SpotrOS Logoo": 160,
	"./Grubspotr-SpotrOS Logoo.png": 160,
	"./Pays-black-logo": 161,
	"./Pays-black-logo.svg": 161,
	"./activated": 162,
	"./activated.png": 162,
	"./basic_logos/bargraph": 163,
	"./basic_logos/bargraph.png": 163,
	"./basic_logos/bargraph1": 164,
	"./basic_logos/bargraph1.png": 164,
	"./basic_logos/bargraph2": 165,
	"./basic_logos/bargraph2.png": 165,
	"./basic_logos/calendar": 166,
	"./basic_logos/calendar.svg": 166,
	"./basic_logos/chart": 167,
	"./basic_logos/chart.png": 167,
	"./basic_logos/clone": 168,
	"./basic_logos/clone.svg": 168,
	"./basic_logos/close": 169,
	"./basic_logos/close-blue": 170,
	"./basic_logos/close-blue.svg": 170,
	"./basic_logos/close.svg": 169,
	"./basic_logos/customer_receipt_logo": 171,
	"./basic_logos/customer_receipt_logo.png": 171,
	"./basic_logos/delete": 172,
	"./basic_logos/delete-orange": 173,
	"./basic_logos/delete-orange.svg": 173,
	"./basic_logos/delete.svg": 172,
	"./basic_logos/diamond": 174,
	"./basic_logos/diamond.png": 174,
	"./basic_logos/dollar": 175,
	"./basic_logos/dollar.png": 175,
	"./basic_logos/download": 176,
	"./basic_logos/download-blue": 177,
	"./basic_logos/download-blue.svg": 177,
	"./basic_logos/download-rounded": 178,
	"./basic_logos/download-rounded.svg": 178,
	"./basic_logos/download.svg": 176,
	"./basic_logos/edit": 179,
	"./basic_logos/edit-orange": 180,
	"./basic_logos/edit-orange.svg": 180,
	"./basic_logos/edit.svg": 179,
	"./basic_logos/export": 181,
	"./basic_logos/export.svg": 181,
	"./basic_logos/file-icon": 182,
	"./basic_logos/file-icon.svg": 182,
	"./basic_logos/loader": 183,
	"./basic_logos/loader.gif": 183,
	"./basic_logos/plus": 184,
	"./basic_logos/plus.svg": 184,
	"./basic_logos/qr_demo_image": 185,
	"./basic_logos/qr_demo_image.svg": 185,
	"./basic_logos/remove": 186,
	"./basic_logos/remove.png": 186,
	"./basic_logos/setting": 187,
	"./basic_logos/setting.svg": 187,
	"./basic_logos/setting_kds": 188,
	"./basic_logos/setting_kds.svg": 188,
	"./basic_logos/snack": 189,
	"./basic_logos/snack.svg": 189,
	"./basic_logos/user": 190,
	"./basic_logos/user.svg": 190,
	"./cart": 191,
	"./cart.png": 191,
	"./check1": 192,
	"./check1.svg": 192,
	"./check2": 193,
	"./check2.svg": 193,
	"./circle": 194,
	"./circle.png": 194,
	"./completed": 195,
	"./completed.png": 195,
	"./dashboard_icons/cash_discount": 196,
	"./dashboard_icons/cash_discount.svg": 196,
	"./dashboard_icons/chart4": 197,
	"./dashboard_icons/chart4.svg": 197,
	"./dashboard_icons/gross_sale": 198,
	"./dashboard_icons/gross_sale.svg": 198,
	"./dashboard_icons/ic_profit": 199,
	"./dashboard_icons/ic_profit.svg": 199,
	"./dashboard_icons/ic_transactions": 200,
	"./dashboard_icons/ic_transactions.svg": 200,
	"./dashboard_icons/refund": 201,
	"./dashboard_icons/refund.svg": 201,
	"./dashboard_icons/reward": 202,
	"./dashboard_icons/reward.svg": 202,
	"./dashboard_icons/service_charge": 203,
	"./dashboard_icons/service_charge.svg": 203,
	"./dashboard_icons/tax": 204,
	"./dashboard_icons/tax.svg": 204,
	"./dashboard_icons/tender": 205,
	"./dashboard_icons/tender.svg": 205,
	"./dashboard_icons/tips": 206,
	"./dashboard_icons/tips.svg": 206,
	"./dashboard_icons/user": 207,
	"./dashboard_icons/user.svg": 207,
	"./favicon": 208,
	"./favicon.jpeg": 208,
	"./floor_plan/chair": 209,
	"./floor_plan/chair.png": 209,
	"./floor_plan/chair_1": 210,
	"./floor_plan/chair_1.png": 210,
	"./floor_plan/table": 142,
	"./floor_plan/table.png": 142,
	"./floor_plan/table.svg": 408,
	"./floor_plan/table_1": 211,
	"./floor_plan/table_1.svg": 211,
	"./gift-card": 212,
	"./gift-card.png": 212,
	"./header_icons/chat": 213,
	"./header_icons/chat.svg": 213,
	"./header_icons/file": 214,
	"./header_icons/file.svg": 214,
	"./header_icons/notification": 215,
	"./header_icons/notification.svg": 215,
	"./header_icons/question": 216,
	"./header_icons/question.svg": 216,
	"./header_icons/search": 217,
	"./header_icons/search.svg": 217,
	"./home/expand": 218,
	"./home/expand.svg": 218,
	"./home/ic_comment": 219,
	"./home/ic_comment.svg": 219,
	"./home/ic_delete": 220,
	"./home/ic_delete.svg": 220,
	"./home/ic_duplicate": 221,
	"./home/ic_duplicate.svg": 221,
	"./home/ic_edit": 222,
	"./home/ic_edit.svg": 222,
	"./home/ic_email": 223,
	"./home/ic_email.svg": 223,
	"./home/ic_events": 224,
	"./home/ic_events.svg": 224,
	"./home/ic_image": 225,
	"./home/ic_image.png": 225,
	"./home/ic_image@2x": 226,
	"./home/ic_image@2x.png": 226,
	"./home/ic_meet": 227,
	"./home/ic_meet.svg": 227,
	"./home/ic_note": 228,
	"./home/ic_note.svg": 228,
	"./home/ic_profile_pic": 229,
	"./home/ic_profile_pic.svg": 229,
	"./home/ic_resend_email": 230,
	"./home/ic_resend_email.svg": 230,
	"./home/ic_times": 231,
	"./home/ic_times.svg": 231,
	"./home/ic_view": 232,
	"./home/ic_view.svg": 232,
	"./home/permission": 233,
	"./home/permission.svg": 233,
	"./home/profile_placeholder": 234,
	"./home/profile_placeholder.svg": 234,
	"./homes/ASingleMenu": 235,
	"./homes/ASingleMenu.png": 235,
	"./homes/Abettercheckoutexperience": 236,
	"./homes/Abettercheckoutexperience.png": 236,
	"./homes/AccessRights": 237,
	"./homes/AccessRights.png": 237,
	"./homes/AddEmployeestoYourTeam": 238,
	"./homes/AddEmployeestoYourTeam.png": 238,
	"./homes/AddnewcustomersdirectlyfromBOLDPOS": 239,
	"./homes/AddnewcustomersdirectlyfromBOLDPOS.png": 239,
	"./homes/Backofhouse2x": 240,
	"./homes/Backofhouse2x.png": 240,
	"./homes/BundleItems": 241,
	"./homes/BundleItems.png": 241,
	"./homes/Call": 242,
	"./homes/Call.svg": 242,
	"./homes/CashDiscount": 243,
	"./homes/CashDiscount.png": 243,
	"./homes/Cloud-based": 244,
	"./homes/Cloud-based-16": 245,
	"./homes/Cloud-based-16.png": 245,
	"./homes/Cloud-based.png": 244,
	"./homes/Cloud2x": 246,
	"./homes/Cloud2x.png": 246,
	"./homes/Color-CodedDisplay": 247,
	"./homes/Color-CodedDisplay.png": 247,
	"./homes/CreateCustomerprofiles": 248,
	"./homes/CreateCustomerprofiles.png": 248,
	"./homes/CustomizeOrderingHours": 249,
	"./homes/CustomizeOrderingHours.png": 249,
	"./homes/Customize_Ordering_Hours": 250,
	"./homes/Customize_Ordering_Hours.png": 250,
	"./homes/DAVOSalesTax": 251,
	"./homes/DAVOSalesTax.png": 251,
	"./homes/DineIn": 252,
	"./homes/DineIn.png": 252,
	"./homes/EasySplit-MergeChecks": 253,
	"./homes/EasySplit-MergeChecks.png": 253,
	"./homes/Exportyourlisttoyouremailmarketingtool": 254,
	"./homes/Exportyourlisttoyouremailmarketingtool.png": 254,
	"./homes/FinalHomeBanner": 143,
	"./homes/FinalHomeBanner.png": 143,
	"./homes/FinalHomeBanner.svg": 409,
	"./homes/GoMobilewithTablesidePOSordering": 255,
	"./homes/GoMobilewithTablesidePOSordering.png": 255,
	"./homes/Group2_150": 256,
	"./homes/Group2_150.png": 256,
	"./homes/Group94": 257,
	"./homes/Group94.png": 257,
	"./homes/ImportyourcustomerlistintoBOLDPOS": 258,
	"./homes/ImportyourcustomerlistintoBOLDPOS.png": 258,
	"./homes/InbuildThemes": 259,
	"./homes/InbuildThemes.png": 259,
	"./homes/Inbuild_Themes": 260,
	"./homes/Inbuild_Themes.png": 260,
	"./homes/Inbuild_Themes@2x": 261,
	"./homes/Inbuild_Themes@2x.png": 261,
	"./homes/Info": 144,
	"./homes/Info.png": 144,
	"./homes/Info.svg": 410,
	"./homes/IngridientManagement": 262,
	"./homes/IngridientManagement.png": 262,
	"./homes/IntelligentReporting": 263,
	"./homes/IntelligentReporting.png": 263,
	"./homes/Itemimport": 264,
	"./homes/Itemimport.png": 264,
	"./homes/Itemmodifiers": 265,
	"./homes/Itemmodifiers.png": 265,
	"./homes/KitchenPrinters": 266,
	"./homes/KitchenPrinters.png": 266,
	"./homes/Labelprinting": 267,
	"./homes/Labelprinting.png": 267,
	"./homes/MailChimp": 268,
	"./homes/MailChimp.png": 268,
	"./homes/MobileResponsiveSite": 269,
	"./homes/MobileResponsiveSite.png": 269,
	"./homes/Mobile_Responsive_Site": 270,
	"./homes/Mobile_Responsive_Site.png": 270,
	"./homes/Mobile_Responsive_Site@2x": 271,
	"./homes/Mobile_Responsive_Site@2x.png": 271,
	"./homes/Multipleproductvariants": 272,
	"./homes/Multipleproductvariants.png": 272,
	"./homes/OpenOrders": 273,
	"./homes/OpenOrders.png": 273,
	"./homes/OrderHistoryReturns": 274,
	"./homes/OrderHistoryReturns.png": 274,
	"./homes/OrderStock": 275,
	"./homes/OrderStock.png": 275,
	"./homes/PayrollSimplified": 276,
	"./homes/PayrollSimplified.png": 276,
	"./homes/QuickBooksOnline": 277,
	"./homes/QuickBooksOnline.png": 277,
	"./homes/Real-timeOrderChanges": 278,
	"./homes/Real-timeOrderChanges.png": 278,
	"./homes/ReservationandWaitlistManagement": 279,
	"./homes/ReservationandWaitlistManagement.png": 279,
	"./homes/SalesbyEmployees": 280,
	"./homes/SalesbyEmployees.png": 280,
	"./homes/Services": 281,
	"./homes/Services.png": 281,
	"./homes/SetPermissionsandRoles": 282,
	"./homes/SetPermissionsandRoles.png": 282,
	"./homes/StockNotifications": 283,
	"./homes/StockNotifications.png": 283,
	"./homes/Stockadjustments": 284,
	"./homes/Stockadjustments.png": 284,
	"./homes/TableManagement": 285,
	"./homes/TableManagement.png": 285,
	"./homes/TakeOut": 286,
	"./homes/TakeOut.png": 286,
	"./homes/Timeclock": 287,
	"./homes/Timeclock.png": 287,
	"./homes/TipPooling": 288,
	"./homes/TipPooling.png": 288,
	"./homes/TrackCookingTimes": 289,
	"./homes/TrackCookingTimes.png": 289,
	"./homes/TrackOrderCompletion": 290,
	"./homes/TrackOrderCompletion.png": 290,
	"./homes/Transferorders": 291,
	"./homes/Transferorders.png": 291,
	"./homes/UnitCostMargins": 292,
	"./homes/UnitCostMargins.png": 292,
	"./homes/Untitled-5": 293,
	"./homes/Untitled-5.svg": 293,
	"./homes/Vendorpurchaseorders": 294,
	"./homes/Vendorpurchaseorders.png": 294,
	"./homes/VisualTableLayouts": 295,
	"./homes/VisualTableLayouts.png": 295,
	"./homes/Whatwillmyguestssee": 296,
	"./homes/Whatwillmyguestssee.png": 296,
	"./homes/android_pos2x": 297,
	"./homes/android_pos2x.png": 297,
	"./homes/arrow": 298,
	"./homes/arrow-2": 299,
	"./homes/arrow-2.svg": 299,
	"./homes/arrow-3": 300,
	"./homes/arrow-3.svg": 300,
	"./homes/arrow.png": 298,
	"./homes/arrow_150": 301,
	"./homes/arrow_150.png": 301,
	"./homes/cash_mgt2x": 302,
	"./homes/cash_mgt2x.png": 302,
	"./homes/contactless_payment": 303,
	"./homes/contactless_payment.png": 303,
	"./homes/customer_receipt2x": 304,
	"./homes/customer_receipt2x.png": 304,
	"./homes/dashboard_analytics": 305,
	"./homes/dashboard_analytics.svg": 305,
	"./homes/discount2x": 306,
	"./homes/discount2x.png": 306,
	"./homes/fast_staff2x": 307,
	"./homes/fast_staff2x.png": 307,
	"./homes/gift_card": 308,
	"./homes/gift_card.svg": 308,
	"./homes/intutive_design2x": 309,
	"./homes/intutive_design2x.png": 309,
	"./homes/line_items2x": 310,
	"./homes/line_items2x.png": 310,
	"./homes/location": 311,
	"./homes/location.svg": 311,
	"./homes/mail": 312,
	"./homes/mail.svg": 312,
	"./homes/marketing": 313,
	"./homes/marketing.svg": 313,
	"./homes/multiple_locations2x": 314,
	"./homes/multiple_locations2x.png": 314,
	"./homes/online_ordering": 315,
	"./homes/online_ordering.png": 315,
	"./homes/pos-fb": 316,
	"./homes/pos-fb.png": 316,
	"./homes/pos-linkedin": 317,
	"./homes/pos-linkedin.png": 317,
	"./homes/pos-twitter": 318,
	"./homes/pos-twitter.png": 318,
	"./homes/product_customer_search": 319,
	"./homes/product_customer_search.png": 319,
	"./homes/qr_code_ordering2x": 320,
	"./homes/qr_code_ordering2x.png": 320,
	"./homes/quick_service": 321,
	"./homes/quick_service.png": 321,
	"./homes/refunds_returns2x": 322,
	"./homes/refunds_returns2x.png": 322,
	"./homes/restaurant": 145,
	"./homes/restaurant.png": 145,
	"./homes/restaurant.svg": 411,
	"./homes/retail": 323,
	"./homes/retail.png": 323,
	"./homes/retail2x": 324,
	"./homes/retail2x.png": 324,
	"./homes/retail_pos": 325,
	"./homes/retail_pos.svg": 325,
	"./homes/service": 326,
	"./homes/service.png": 326,
	"./homes/set": 146,
	"./homes/set.png": 146,
	"./homes/set.svg": 412,
	"./homes/split_payment2x": 327,
	"./homes/split_payment2x.png": 327,
	"./homes/things-to-consider-food-app": 328,
	"./homes/things-to-consider-food-app.jpg": 328,
	"./homes/virtual_terminal": 329,
	"./homes/virtual_terminal.svg": 329,
	"./homes/work_offline2x": 330,
	"./homes/work_offline2x.png": 330,
	"./ic_fav": 331,
	"./ic_fav.svg": 331,
	"./ic_info": 332,
	"./ic_info.svg": 332,
	"./ic_pin": 333,
	"./ic_pin.png": 333,
	"./ic_radio": 334,
	"./ic_radio.png": 334,
	"./items/demo_image": 335,
	"./items/demo_image.jpg": 335,
	"./kds/KDS": 336,
	"./kds/KDS-2": 337,
	"./kds/KDS-2.svg": 337,
	"./kds/KDS.svg": 336,
	"./kds/KDS2": 338,
	"./kds/KDS2.svg": 338,
	"./kds/back": 339,
	"./kds/back.svg": 339,
	"./kds/cancelled_order": 340,
	"./kds/cancelled_order.png": 340,
	"./kds/check": 341,
	"./kds/check.svg": 341,
	"./kds/loading_spinner": 342,
	"./kds/loading_spinner.gif": 342,
	"./kds/refund": 343,
	"./kds/refund.jpeg": 343,
	"./kds/refunded": 344,
	"./kds/refunded.png": 344,
	"./kds/settings": 345,
	"./kds/settings.svg": 345,
	"./logo": 346,
	"./logo.svg": 346,
	"./online_ordering_settings_images/close": 147,
	"./online_ordering_settings_images/close.png": 147,
	"./online_ordering_settings_images/close.svg": 413,
	"./online_ordering_settings_images/full_banner": 347,
	"./online_ordering_settings_images/full_banner.png": 347,
	"./online_ordering_settings_images/half_banner": 348,
	"./online_ordering_settings_images/half_banner.png": 348,
	"./online_ordering_settings_images/theme1": 349,
	"./online_ordering_settings_images/theme1.png": 349,
	"./online_ordering_settings_images/theme2": 350,
	"./online_ordering_settings_images/theme2.png": 350,
	"./online_ordering_settings_images/theme3": 351,
	"./online_ordering_settings_images/theme3.png": 351,
	"./owl.video.play": 352,
	"./owl.video.play.png": 352,
	"./pays-white": 353,
	"./pays-white.jpeg": 353,
	"./pos": 354,
	"./pos-card": 355,
	"./pos-card.png": 355,
	"./pos.png": 354,
	"./printer/bluetooth": 356,
	"./printer/bluetooth.svg": 356,
	"./printer/lan": 357,
	"./printer/lan.svg": 357,
	"./printer/printer": 358,
	"./printer/printer.svg": 358,
	"./product_large_images/cashdrawer": 359,
	"./product_large_images/cashdrawer(600)": 360,
	"./product_large_images/cashdrawer(600).png": 360,
	"./product_large_images/cashdrawer.png": 359,
	"./product_large_images/paper": 361,
	"./product_large_images/paper(600)": 362,
	"./product_large_images/paper(600).png": 362,
	"./product_large_images/paper.png": 361,
	"./product_large_images/printer1": 363,
	"./product_large_images/printer1(600)": 364,
	"./product_large_images/printer1(600).png": 364,
	"./product_large_images/printer1.png": 363,
	"./product_large_images/printer2": 365,
	"./product_large_images/printer2(600)": 366,
	"./product_large_images/printer2(600).png": 366,
	"./product_large_images/printer2.png": 365,
	"./product_large_images/scan": 367,
	"./product_large_images/scan(600)": 368,
	"./product_large_images/scan(600).png": 368,
	"./product_large_images/scan.png": 367,
	"./product_large_images/stand": 369,
	"./product_large_images/stand(600)": 370,
	"./product_large_images/stand(600).png": 370,
	"./product_large_images/stand.png": 369,
	"./receipt/cancelled_order": 371,
	"./receipt/cancelled_order.png": 371,
	"./reports/filter": 372,
	"./reports/filter.svg": 372,
	"./reports/info": 373,
	"./reports/info.svg": 373,
	"./reports/info_white": 374,
	"./reports/info_white.svg": 374,
	"./search": 375,
	"./search.svg": 375,
	"./snack-logo": 376,
	"./snack-logo-black": 148,
	"./snack-logo-black.jpeg": 414,
	"./snack-logo-black.png": 148,
	"./snack-logo-black_new": 377,
	"./snack-logo-black_new.jpeg": 377,
	"./snack-logo-black_old": 378,
	"./snack-logo-black_old.svg": 378,
	"./snack-logo-black_old_old": 379,
	"./snack-logo-black_old_old.svg": 379,
	"./snack-logo.svg": 376,
	"./snack_logo": 380,
	"./snack_logo.svg": 380,
	"./success": 381,
	"./success.svg": 381,
	"./true-sign": 382,
	"./true-sign.png": 382
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;